// extracted by mini-css-extract-plugin
export var scrollArea = "_qu-0";